// extracted by mini-css-extract-plugin
module.exports = {"splashScreen":"style_splashScreen__2HTic","splashLoading":"style_splashLoading__1a8e3"};